import { render, staticRenderFns } from "./GroupManagementModal.vue?vue&type=template&id=72fcccf6&scoped=true&"
import script from "./GroupManagementModal.vue?vue&type=script&lang=js&"
export * from "./GroupManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagementModal.vue?vue&type=style&index=0&id=72fcccf6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fcccf6",
  null
  
)

export default component.exports